// extracted by mini-css-extract-plugin
export default {"appHorizontalNav":"AppHorizontalNav_appHorizontalNav__T54xd"};